import PicoContext from './PicoContext';

class PicoUtils {

    private static contexts: Map<string, PicoContext> = new Map<string, PicoContext>();

    private constructor() {
        // blcok to access from outside of this class
    }

    public static getContext(modulepath: string, showTitle: boolean): PicoContext {
        let context = this.contexts.get(modulepath);
        if (typeof context === 'undefined') {
            context = new PicoContext(modulepath, showTitle);
            this.contexts.set(modulepath, context);
        }
        return context;
    }

}

export default PicoUtils;
